import React, { useEffect, useState } from 'react';
import { hasChildren } from "./utils";
import SingleLevel from './SingleLevel';
import "./MultiLevel.css";

export const MenuItem = ({ item, setskin_menu }) => {
   // console.log('MenuItem called....')
   const Component = hasChildren(item) ? MultiLevel : SingleLevel;
   return <Component setskin_menu={setskin_menu} item={item} />;
};
export const MultiLevel = ({ item, setskin_menu }) => {
   const [orentation, setOrentation] = useState((window.mob || window.isipad) && window.innerHeight > window.innerWidth ? 0 : 90)
   const { items: children } = item;
   const [open, setOpen] = useState(false);
   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';
   useEffect(() => {

      if (item.id === "Exterior") {
         document.getElementById("Exterior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.add('menuActive');
      }
      document.getElementById("Exterior").previousSibling.classList.add('mainMenuAccordion');
      document.getElementById("Interior").previousSibling.classList.add('mainMenuAccordion');
      document.getElementById("menubtnxr").previousSibling.classList.add('mainMenuAccordion');


      if (window.innerHeight > window.innerWidth) {
         setOrentation(90);

      } else {
         setOrentation(0);
      }
   }, []);

   const handleClick = (menuname, sequenceName) => {
        window.navigationStatus = false;
    
      window.hideCallouts();
      if(window.playVideo) window.pauseVideo();   
      if (document.getElementById("footerControl") != undefined) document.getElementById("footerControl").style.display = 'block';
     window.hideAllHotspot();
     
      var menuTitle = item.title;            
      // console.log("menuTitle", menuTitle);
      // window.RT_RecordEvent(menuTitle, window.configProduct.name); 
      clearTimeout(window.myTimeout);
      clearTimeout(window.clearsettimeout);
      if (!window.menuClick) return;
      window.currentPosition = '';
      window.hidePopUp();
      document.body.classList.remove('hotspotShow');
         setTimeout(() => {
            window.menuHeightCalaulate();
         }, 20);
      if (document.getElementById("rest_button") != undefined) document.getElementById("rest_button").style.display = "none";
      sequenceName && window.scene.applySequence(window[sequenceName]);
      window.hideAllPopup();
      window.hideActivePopup();
      clearInterval(window.Interval1);
      clearInterval(window.Interval2);
      window.scene._nav.SetRotationCenter([0, 0, 0]);
      // window.scene._nav._fRotMinLimitConst = 0.3; 
      var getBodyTag = document.getElementsByTagName("body")[0];
      var getBodyClass = getBodyTag.classList.contains('desktopdevice');
      if (!window.mob || (window.isipad && window.innerWidth > window.innerHeight) || getBodyClass) {
         var exteriorMenu = document.querySelector("#Exterior .MuiList-root");
         var exteriorMenuHeight = exteriorMenu.clientHeight;
         var menuInterior = document.querySelector("#menuInterior .MuiList-root");
         var menuInteriorHeight = menuInterior.clientHeight;
      }

      if (window.mob || (window.isipad && window.innerHeight > window.innerWidth)) {
         const mob_skin_icon = document.getElementsByClassName("mob_skin_icon");
         for (let i = 0; i < mob_skin_icon.length; i++) {
            mob_skin_icon[i].style.display = 'none';
            mob_skin_icon[i].classList.remove('active');
         }
         setskin_menu(false);
      }
      if (menuname === 'Exterior') {
         // window.pauseVideo();
         let hotspotsActive = [...document.querySelectorAll(".hotspots")];
         hotspotsActive.forEach(ele => {
            ele.style.display = "flex";
         });
         if (window.mob || window.isipadPortrait) {
            setTimeout(() => {
               if (document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "block";

            }, 800);
         }
         else {
            setTimeout(() => {
               if (document.getElementById("exterior_title") != undefined) document.getElementById("exterior_title").style.display = "block";
               if (document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "none";

            }, 1000);

         }

         if (!window.mob || (!window.isipad && window.innerHeight > window.innerWidth) || getBodyClass) {
            document.getElementById('Interior').style.height = "0px";
            document.getElementById('Exterior').style.height = exteriorMenuHeight + "px";
         }
         window.hideAllPopup();
         if (window.mob || window.isipad) {
            setTimeout(() => {
               if (document.querySelector('.MuiCollapse-wrapper')) {
                  document.querySelectorAll('.MuiCollapse-wrapper').forEach(wrapeer => wrapeer.scrollTo({ behavior: 'smooth', top: 0 }))
               }
            }, 500);
         }
         document.getElementById("Exterior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         document.getElementById("Exterior").previousSibling.classList.add('menuActive');
         if (window.selectedMenu.cameraType != 'exterior') { window.fadeIn(window.reset) }
         else { window.reset() }
         window.selectedMenu.cameraType = 'exterior';
         if (!window.mob) {
            window.selectedMenu.active = "Render_Cam_FR_F05";
         }
         setTimeout(window.fadeOut, 1200)

         const content1 = document.getElementsByClassName("content1");
         for (let i = 0; i < content1.length; i++) {
            content1[i].style.maxHeight = null;
         }

         // window.RT_RecordEvent("Exterior", "Exterior", window.configProduct.name);
        

         window.navLimits.minDolly = 80;
         window.navLimits.maxDolly = 250;
         window.navLimits.panLeft = 10;
         window.navLimits.panRight = -18;
         window.navLimits.panTop = 5;
         window.navLimits.panBottom = 32;
         window.updateZoombar(118, 137);
         window.scene._nav.SetNavLimits(window.navLimits);
         window.scene.clearRefine();

      }
      else if (menuname === 'Interior') {
         // window.pauseVideo();
         let hotspotsActive = [...document.querySelectorAll(".hotspots")];
         hotspotsActive.forEach(ele => {
            if (ele) {
               ele.style.display = "none";
            }
         });
         if (window.mob || window.isipad) {
            setTimeout(() => {
               if (document.querySelector('.MuiCollapse-wrapper')) {
                  document.querySelectorAll('.MuiCollapse-wrapper').forEach(wrapeer => wrapeer.scrollTo({ behavior: 'smooth', top: 0 }))
               }
            }, 500);
         }
         if (window.mob || window.isipadPortrait) {
            if (document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "none";
         } else {
            if (document.getElementById("exterior_title") != undefined) document.getElementById("exterior_title").style.display = "none";
            if (document.getElementById("exterior_text_mob")) document.getElementById('exterior_text_mob').style.display = 'none';
         }
         window.hideAllPopup();
         if (!window.mob || (!window.isipad && window.innerHeight > window.innerWidth) || getBodyClass) {
            document.getElementById('Exterior').style.height = "0px";
            document.getElementById('Interior').style.height = menuInteriorHeight + 20 + "px";
         }
         document.getElementById('Exterior').style.height = "0px";
         window.scene.setMaterialTransition(true, false, 200);
         document.getElementById("Interior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").classList.add('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
         document.getElementById("Interior").previousSibling.classList.add('menuActive');
         window.animStoped = false;
         if (window.selectedMenu.cameraType != 'interior') { window.fadeIn(window.interiorClick); }
         else { window.interiorClick() }

         window.selectedMenu.cameraType = 'interior';
         window.selectedMenu.active = "Render_Cam_Explode_F30";

         setTimeout(window.fadeOut, 0)
         window.navLimits.minDolly = 60;
         window.navLimits.maxDolly = 220;
         window.navLimits.panLeft = 5;
         window.navLimits.panRight = -12;
         window.navLimits.panTop = -5;
         window.navLimits.panBottom = 20;
         // window.scene._nav._fRotMinLimitConst = 0.3
         window.updateZoombar(117, 131);
         const content2 = document.getElementsByClassName("content1");
         for (let i = 0; i < content2.length; i++) {
            content2[i].style.maxHeight = null;
         }

         // window.RT_RecordEvent("Explode","Explode View",window.configProduct.name);
         window.scene.clearRefine();
      }
      else {
         document.getElementById("Interior").classList.remove('MuiCollapse-hidden');
          if(window.selectedMenu.active == 'Render_Cam_AI_Turbo_Engine_F01' || window.selectedMenu.active == 'Render_Cam_Wireless_Charging_F05') {
            window.navigationStatus = true;
         }
         // document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         
         // document.getElementById("Exterior").previousSibling.classList.remove('menuActive');

      }
      setTimeout(() => {
         const collection = document.getElementsByClassName("menu");
         for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove('active');
         }
      }, 1000);

      window.resetpop();
      window.calloutPositionReset();
      setTimeout(function () {
         window.updateZoomSlider(window.sliderEl3, window.scene._nav.getZoomFactor());
      }, 2000);

   };

  return (
      // <div className="menu" id={item.id === 'btnXR' ? arbuttonName : 'menu' + item.id} style={item.id === 'btnXR' ? { 'display': 'none' } : {}}>
      <div className="menu" id={item.id === 'btnXR' ? arbuttonName : 'menu' + item.id}>
         <div className="MuiButtonBase-root MuiListItem-root MuiListItem-gutters MuiListItem-button" onClick={() => { handleClick(item.id, item.sequenceName) }}>
            {(window.mob || window.innerHeight > window.innerWidth) ?
               <div className="MuiListItemIcon-root">
                  <img className={`icondiv${item.id}`} src={item.icon} alt={item.title} />
               </div>
               : <div className="MuiListItemIcon-root">
                  <img className={`icondiv${item.id}`} alt={item.title} />
               </div>
            }
            <div className="title">
               <span className="MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock">{item.id === 'Interior' && (window.mob || window.innerHeight > window.innerWidth) ? 'Explode' : item.title}</span>
            </div>
         </div>
         <div className={`MuiCollapse-container ${open ? 'open' : ''}`} id={item.id === 'btnXR' ? 'menubtnxr' : item.id}>
            {/* <div className="MuiList-root MuiList-padding"> */}
               <div className="MuiCollapse-wrapper">
                  <div className="MuiCollapse-wrapperInner">
                     <div className="MuiList-root MuiList-padding">
                     {children.map((child, key) => (
                        <MenuItem key={key} item={child} setskin_menu={setskin_menu} />
                     ))}                     
                  </div>
                  </div>
               </div>
            {/* </div> */}
         </div>
      </div>
   );
};
//  export default MultiLevel
